import { rapid } from './rapid.js';
import { blitz } from './blitz.js';
import { siege } from './siege.js';

// Three modes, deliberately pulling in three different directions: hands
// (rapid), curve (blitz), and decisions (siege). Everything else in the game is
// the fourth: patience.
export const MODES = [rapid, blitz, siege];

export function modeFor(id) { return MODES.find((mode) => mode.id === id); }
